// Booking goes through the server — token never exposed to the client
export async function sendBookingToTelegram(data) {
  const res = await fetch('/api/booking', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to send booking');
}
